import type { PropsWithChildren } from 'react';

import { UploadProgressStyled } from './styles/UploadProgressStyled'
import { type UploadCommonProps } from '../../Upload'
import { Progress } from '@ui/elements/Progress'

export interface IUploadProgressProps {
  commonProps: UploadCommonProps
  innerProps: {
    progress: number
  }
}

export const UploadProgress = ({
  innerProps,
}: PropsWithChildren<IUploadProgressProps>) => {
  const { progress } = innerProps

  return (
    <UploadProgressStyled>
      <Progress variant='determinate' value={progress} />
    </UploadProgressStyled>
  )
}
